import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AcademyBrandingStateService {
  private readonly logoSubject = new BehaviorSubject<string | null>(null);

  readonly logo$ = this.logoSubject.asObservable().pipe(distinctUntilChanged());

  setLogo(logoUrl: string | null | undefined): void {
    this.logoSubject.next(logoUrl || null);
  }
}
